/* eslint-disable */
/* istanbul ignore file */
(function () {
    if (window._fitAnalytics) return;

    var shop = {
        prefix: 'outnet-',
        products: {},
        isMobile: /iphone|android|iemobile|blackberry/i.test(window.navigator.userAgent) && 'ontouchstart' in window,
        el: {
            productContainer: 'div[class^="ProductDetailsPage"]',
            sizes: 'ul[class^="GridSelect"] li',
            addToCart: 'div[class^="AsyncButton"] button[class^="Button"].primaryButton',
            thumbnail:
                'div[class^="ImageCarousel"][class*="active"] img[class*="loaded"], div[class^="ImageCarousel"][class*="active"] img[class*="image--undefined"]',
            thumbnailMobile: 'div[class*="mainCarousel"] li[class*="_slide"].active img',
            productIds: 'div[class^="ProductDetailsColours"] ul li[class*="__swatch"] a',
            getPromptAnchor: () => {
                return 'div.fitAnalytics';
            },
            resultsAnchor: 'div.fitAnalyticsResults',
            sizeChart: 'a[class*="__sizeGuideLink"]',
            singleSize: 'span[class*="__oneSizeLabel"]',
        },
        hideSizeChart: false,
        blockedLocales: ['en_JP'], // array of locales we want to block e.g ['it_IT', 'de_DE'], otherwise leave empty
        recommendationPercentage: [
            { size: null, match: null },
            { size: null, match: null },
        ],
        initialize: function () {
            var loadAttempts = 0;
            var checkIfLoaded = setInterval(function () {
                if (shop.isLoaded()) {
                    clearInterval(checkIfLoaded);
                    shop.onLoaded();
                } else if (loadAttempts > 10) {
                    clearInterval(checkIfLoaded);
                } else {
                    loadAttempts += 1;
                }
            }, 1000);
        },

        isLoaded: function () {
            return typeof window.FitAnalyticsWidget === 'function';
        },

        isBlockedLocale: function () {
            var lang = shop.getLanguage(),
                currentLocale = [lang, shop.getCountry()].join('_');

            return !!(shop.blockedLocales.indexOf(currentLocale) > -1) || lang !== 'en';
        },

        onLoaded: function () {
            shop.$ = FitAnalyticsWidget.jQuery;
            shop._ = FitAnalyticsWidget._;
            if (shop.isDataAvailable() && !shop.isBlockedLocale()) shop.onPageLoaded();
        },

        isDataAvailable: function () {
            var serial = shop.getCurrentSerial();

            // var language = shop.getLanguage(),
            //     country = shop.getCountry(),
            //     sizes = shop.getSizes(),
            //     userId = shop.getUserId(),
            //     thumbnail = shop.getThumbnail();

            // console.log('~~~ Available Data ~~~');
            // console.log('Current Serial: ', serial);
            // console.log('Language: ', language);
            // console.log('Shop Country: ', country);
            // console.log('Sizes: ', sizes);
            // console.log('User ID: ', userId);
            // console.log('Thumbnail: ', thumbnail);
            // console.log('~~~~~~~~~~~~~~~~~~~~~~');

            return !!serial;
        },

        // finds jQuery selections only within the current product container
        find: function (selector) {
            return shop.getContainer().find(selector);
        },

        getContainer: function () {
            return shop.$(shop.el.productContainer).first();
        },

        getPrivacyLabel: function () {
            return 'The OUTNET privacy policy';
        },

        getPrivacyUrl: function () {
            var lang = shop.getLanguage(),
                country = shop.getCountry().toLowerCase();

            return `https://www.theoutnet.com/${lang}-${country}/page/help/privacy-policy`;
        },

        // get the current serial without shop prefix
        getCurrentRawSerial: function () {
            var thumbnail = shop.getThumbnail(),
                serial = thumbnail && thumbnail.match(/images\/(\d*)/);

            return serial ? serial.pop() : '';
        },

        getCurrentSerial: function () {
            var rawSerial = shop.getCurrentRawSerial();
            return rawSerial && shop.prefix + rawSerial;
        },

        isOneSizePDP: function () {
            var sizesCount = shop.find(shop.el.sizes).length;

            return !sizesCount;
        },

        getSizes: function () {
            var sizes = [];
            sizes.dic = {};
            sizes.state = {};

            if (!shop.isOneSizePDP()) {
                shop.find(shop.el.sizes)
                    .toArray()
                    .forEach(function (el) {
                        var $el = shop.$(el),
                            size = trim($el.text()),
                            isAvailable = !($el.find('label').attr('aria-label').indexOf('sold out') > -1);

                        if (size) {
                            sizes.state[size] = isAvailable;
                            if (isAvailable) {
                                sizes.push(size);
                                sizes.dic[size] = $el.find('input');
                            }
                        }
                    });
            } else {
                var size = shop.find(shop.el.singleSize).text();

                if (size) {
                    sizes.state[size] = true;
                    sizes.push(size);
                    sizes.dic[size] = '';
                }
            }
            return sizes;
        },

        getLocale: function () {
            var locale = lookup(window, 'state.appState.locale', false);

            return locale;
        },

        getLanguage: function () {
            var locale = shop.getLocale();

            return locale ? locale.substring(0, 2).toLowerCase() : '';
        },

        getCountry: function () {
            var locale = shop.getLocale();

            return locale ? locale.substring(3, 5).toUpperCase() : '';
        },

        getThumbnail: function () {
            return (
                shop
                    .find(shop.isMobile ? shop.el.thumbnailMobile : shop.el.thumbnail)
                    .first()
                    .attr('src') || ''
            );
        },

        getUserId: function () {
            return '';
        },

        getSizeChart: function () {
            return shop.find(shop.el.sizeChart);
        },

        getContext: function (serial) {
            return shop.products[serial];
        },

        setContext: function (serial, props) {
            return (shop.products[serial] = shop._.extend({}, shop.products[serial], props));
        },

        onPageLoaded: function () {
            shop.loadWidget();
            shop.checkForProductChange();
            shop.attachMetricsListener();
        },

        attachMetricsListener: function () {
            shop.getSizeChart()
                .addClass('fitAnalytics__sizechart_metrics')
                .off('click.fita')
                .on('click.fita', function () {
                    shop.widget.meterClick('sizeChart', { garmentId: shop.getCurrentSerial() });

                    if (shop.ABTest.isActive()) {
                        shop.widget.meterABTestSizeChartOpen();
                    }
                });
        },

        ATC: function (size) {
            var timeout = 100;
            waitForLoading = setInterval(function () {
                timeout--;

                if (!shop.$(shop.el.addToCart).hasClass('animating')) {
                    tap(shop.getSizes().dic[size]);
                    tap(shop.find(shop.el.addToCart));
                    clearInterval(waitForLoading);
                } else if (!timeout) {
                    clearInterval(waitForLoading);
                }
            }, 200);
        },

        loadWidget: function () {
            shop.widget = new window.FitAnalyticsWidget({
                language: shop.getLanguage(),
                shopCountry: shop.getCountry(),
                userId: shop.getUserId(),
                shopPrivacyUrl: shop.getPrivacyUrl(),
                shopPrivacyLabel: shop.getPrivacyLabel(),
                recommend: function (productId, size, details) {
                    shop.recommend(productId, size, details);
                },
                cart: function (productId, size, details) {
                    shop.recommend(productId, size, details);
                    shop.ATC(size);
                },
                close: function (productId, size, details) {
                    shop.recommend(productId, size, details);
                    shop.button.find().focus();
                },
                open: function () {
                    Object.keys(shop.products).forEach(function (productId) {
                        var product = shop.products[productId] || {};
                        product.recommendation = null;
                    });
                },

                metricEvent: function (eventName, value, details) {
                    var retrieveRecPerc = (purchasedSize) => {
                        var array = [cloneObject(shop.recommendationPercentage[0]), cloneObject(shop.recommendationPercentage[1])];

                        if (purchasedSize) {
                            array.forEach((recommendation) => {
                                if (recommendation.size === purchasedSize) {
                                    recommendation.added = true;
                                } else {
                                    recommendation.added = false;
                                }
                            });
                        }
                        return array;
                    };

                    var eventNameVal = eventName + ' ' + value,
                        eventTypes = {
                            landed: {
                                event: 'Fit Finder - view - ' + eventName,
                                effect: 'View next screen',
                                getAttributes: () => {
                                    return null;
                                },
                            },
                            'close results-cart': {
                                event: 'Fit Finder - add to bag',
                                effect: 'update cart',
                                getAttributes: () => {
                                    return {
                                        productSize: details.lastSize,
                                        productPartNumber: shop.getCurrentRawSerial(),
                                        recommendedSizes: retrieveRecPerc(details.lastSize),
                                    };
                                },
                            },
                            'productLoad true': {
                                event: 'Fit Finder - load',
                                effect: 'script loaded',
                                getAttributes: () => {
                                    return {
                                        recommendedSizes: retrieveRecPerc(),
                                    };
                                },
                            },
                            'open V3': {
                                event: 'Fit Finder - open',
                                effect: 'open modal',
                                getAttributes: () => {
                                    return {
                                        recommendedSizes: retrieveRecPerc(),
                                    };
                                },
                            },
                            sizeRecommendation: {
                                event: 'Fit Finder - complete',
                                effect: 'recommendation provided',
                                getAttributes: () => {
                                    return {
                                        recommendedSizes: retrieveRecPerc(),
                                    };
                                },
                            },
                        };

                    if (eventName === 'immediateRecommendation' || eventName === 'sizeRecommendation') {
                        shop.recommendationPercentage[0].size = details.primarySize || null;
                        shop.recommendationPercentage[0].match = details.primarySizePercentage || null;
                        shop.recommendationPercentage[1].size = details.secondarySize || null;
                        shop.recommendationPercentage[1].match = details.secondarySizePercentage || null;
                    }

                    if (eventTypes[eventName] || eventTypes[value]) {
                        shop.sendToDataLayer(eventTypes[eventName] || eventTypes[value]);
                    } else if (eventTypes[eventNameVal]) {
                        shop.sendToDataLayer(eventTypes[eventNameVal]);
                    }
                },
            });
        },

        sendToDataLayer: function (eventType) {
            //delay is required for 'Fit Finder - load' & 'Fit Finder - complete' metrics to be sent with up-to-date recommendation %
            setTimeout(function () {
                window.dataLayer.push(shop.constructGTMEvent(eventType));
            }, 1500);
        },

        constructGTMEvent: function (eventType) {
            return {
                event: eventType.event,
                effect: eventType.effect,
                category: {
                    primaryCategory: 'fit finder',
                    subCategory: 'product page',
                },
                attributes: eventType.getAttributes(),
            };
        },

        recommend: function (productId, size, details) {
            shop.addRecommendationToContext(productId, size, details);
            shop.button.update(size, details);
        },

        addRecommendationToContext: function (productId, size, details) {
            shop.setContext(productId, {
                recommendation: {
                    size: size,
                    details: details,
                },
            });
        },

        checkForProductChange: function () {
            (function () {
                var serial;
                setInterval(function () {
                    var currentSerial = shop.getCurrentSerial();
                    if (serial !== currentSerial) {
                        serial = currentSerial;
                        if (serial) shop.onProductChange();
                    }
                    if (shop.find('.fitAnalytics__sizechart_metrics').length == 0) {
                        shop.attachMetricsListener();
                    }
                }, 200);
            })();
        },

        onProductChange: function () {
            var serial = shop.getCurrentSerial();

            shop.setContext(serial, { isSupported: false });
            shop.reconfigure();
        },

        reconfigure: function () {
            var serial = shop.getCurrentSerial();

            shop.widget.reconfigure({ productId: serial }, shop.onProductLoaded, shop.onProductError);
        },

        onProductLoaded: function () {
            var serial = shop.getCurrentSerial();
            shop.setContext(serial, { isSupported: true });
            shop.widget.meterProductVisit(serial, true);
            if (shop.ABTest.isActive()) {
                shop.ABTest.reportFunnel();
                shop.ABTest.install();
            } else {
                shop.installButton();
            }
        },

        onProductError: function () {
            if (shop.ABTest.isActive()) {
                shop.ABTest.reportFunnel();
            }
            shop.widget.meterProductVisit(shop.getCurrentSerial(), false);
            shop.button.hide();
        },

        installButton: function () {
            shop.button.install();
            shop.setRecommendation();

            if (shop.hideSizeChart) shop.getSizeChart().hide();
            shop.button.show();
        },

        setRecommendation: function () {
            var product = shop.getContext(shop.getCurrentSerial());
            if (product.recommendation) {
                shop.button.update(product.recommendation.size, product.recommendation.details);
            } else {
                product.recommendation = true;
                shop.getRecommendation();
            }
        },

        getRecommendation: function () {
            shop.widget.getRecommendation({
                productId: shop.getCurrentSerial(),
                thumb: shop.getThumbnail(),
                manufacturedSizes: shop.getSizes().state,
            });
        },

        button: {
            elementId: 'fitanalytics__button',
            containerId: 'fitanalytics__container',
            resultsId: 'fitanalytics__results',

            isValidSize: function (size, details) {
                return !!(typeof size === 'string' && typeof shop.getSizes().state[size] === 'boolean' && !details.outOfRange);
            },

            update: function (size, details) {
                if (shop.button.isValidSize(size, details)) {
                    // show results
                    shop.$('#' + shop.button.resultsId + '-size').text(size);
                    shop.$('#' + shop.button.resultsId).css('display', 'flex');
                    // hide prompt
                    shop.$('#' + shop.button.containerId).hide();
                } else {
                    shop.$('#' + shop.button.containerId).css('display', 'flex');
                    shop.$('#' + shop.button.resultsId).hide();
                }
            },
            buildPrompt: function () {
                return shop
                    .$('<div></div>')
                    .attr({
                        id: this.containerId,
                    })
                    .css({
                        height: '25px',
                        display: 'none',
                        width: '100%',
                        'align-items': 'center',
                        'flex-direction': 'column',
                    })
                    .append(
                        shop
                            .$('<a></a>')
                            .attr({
                                id: this.elementId,
                                tabindex: '0',
                                role: 'button',
                                'aria-label': 'Find your size',
                            })
                            .css({
                                position: 'absolute',
                                cursor: 'auto',
                                width: 'auto',
                                'text-align': 'center',
                            })
                            .on('keypress', this.onKeyboardPress)
                            .on('click', this.onClick)
                            .append(
                                shop
                                    .$('<img>')
                                    .attr({
                                        alt: 'Find your size',
                                        src: '//integrations.fitanalytics.com/shop/outnet/outnet-hanger.svg',
                                        onmouseover: 'this.style.opacity=0.8;return false;',
                                        onmouseleave: 'this.style.opacity=1;return false;',
                                    })
                                    .css({
                                        width: '22px',
                                        height: '22px',
                                        cursor: 'pointer',
                                        display: 'inline-block',
                                        'margin-right': '10px',
                                    }),
                            )
                            .append(
                                shop
                                    .$('<span></span>')
                                    .attr({
                                        class: 'fitanalytics__button-text',
                                        onmouseover: 'this.style.textDecoration="none";return false;',
                                        onmouseleave: 'this.style.textDecoration="underline";return false;',
                                    })
                                    .css({
                                        display: 'inline-block',
                                        'text-decoration': 'underline',
                                        cursor: 'pointer',
                                        'vertical-align': 'top',
                                        font: '16px/1.375 TheOutnetWebXL,Arial',
                                        'line-height': '23px',
                                    })
                                    .text('Find your size'),
                            ),
                    );
            },
            buildResults: function () {
                return shop
                    .$('<div></div>')
                    .attr({
                        id: shop.button.resultsId,
                    })
                    .css({
                        height: '38px',
                        display: 'flex',
                        'align-items': 'center',
                        'flex-direction': 'column',
                        display: 'none',
                    })
                    .append(
                        shop
                            .$('<a></a>')
                            .attr({
                                tabindex: '0',
                                role: 'button',
                                'aria-label': 'Your recommended size',
                            })
                            .css({
                                display: 'flex',
                                gap: '8px',
                                'align-items': 'center',
                                font: '16px/1.375 TheOutnetWebXL,Arial',
                            })
                            .on('keypress', this.onKeyboardPress)
                            .on('click', this.onClick)
                            .append(
                                shop
                                    .$('<span></span>')
                                    .attr({
                                        id: shop.button.resultsId + '-size',
                                        onmouseover: 'this.style.opacity=0.8;return false;',
                                        onmouseleave: 'this.style.opacity=1;return false;',
                                    })
                                    .css({
                                        'border-radius': '18px',
                                        padding: '2px 8px',
                                        'background-color': '#777',
                                        color: 'white',
                                        'font-weight': 'bold',
                                    }),
                            )
                            .append(
                                shop
                                    .$('<span></span>')
                                    .attr({
                                        id: shop.button.resultsId + '-size-text',
                                        onmouseover: 'this.style.textDecoration="none";return false;',
                                        onmouseleave: 'this.style.textDecoration="underline";return false;',
                                    })
                                    .text('Your recommended size'),
                            ),
                    );
            },

            isInitialized: false,
            show: function () {
                this.find().show();
            },
            hide: function () {
                this.find().hide();
            },
            find: function () {
                return shop.find('#' + this.elementId);
            },
            onClick: function () {
                shop.widget.meterClick('sizeAdvisor', { garmentId: shop.getCurrentSerial() });
                shop.widget.open({
                    productId: shop.getCurrentSerial(),
                    thumb: shop.getThumbnail(),
                    manufacturedSizes: shop.getSizes().state,
                });

                window.optimizelyCreateInstance.track('pdp_clicksonFitFinder');
                return false;
            },
            onKeyboardPress: function (e) {
                e.preventDefault();
                var code = e.which;
                if (code === 13 || code === 32) {
                    shop.button.onClick();
                }
            },
            install: function () {
                if (this.find().length) return;
                var prompt = this.buildPrompt();
                shop.find(shop.el.getPromptAnchor()).first().append(prompt);

                var results = this.buildResults();
                shop.find(shop.el.resultsAnchor).first().append(results);
            },
        },
        ABTest: {
            getFunnel: function () {
                var experimentArr = window.fit_analytics || [];
                return experimentArr.length > 1 ? experimentArr[1] : null;
            },
            reportFunnel: function () {
                var funnel = this.getFunnel();
                shop.widget.meterExternalAB(funnel, { garmentId: shop.getCurrentSerial() });
            },
            isActive: function () {
                return !!(window.fit_analytics && window.fit_analytics.indexOf('in-experiment') > -1);
            },
            install: function () {
                var funnel = this.getFunnel();
                if (funnel === 'v1') {
                    shop.installButton();
                }
            },
        },
    };

    function init() {
        // add the widget code to the page, once it loads
        var scriptElem = document.createElement('script');
        scriptElem.setAttribute('src', '//widget.fitanalytics.com/widget_zepto.js');
        scriptElem.setAttribute('type', 'text/javascript');
        document.body.appendChild(scriptElem);

        shop.initialize();

        // cleanup any previous integration
        window._fitAnalytics = window._upcload = function () {};
        window._fitAnalytics.shop = shop;
    }

    // use click, tap and select elements as a user would
    var tap = function ($el) {
        if (!$el || !shop.$) {
            return false;
        }
        if (!($el instanceof shop.$ || (shop.$.zepto && shop.$.zepto.isZ($el)))) {
            $el = shop.$($el);
        }

        if (typeof $el.prop === 'function' && $el.prop('tagName') === 'OPTION') {
            $el.parent().val($el.val()).change();
            // sometimes the .change() command won't trigger a SELECT menu properly, if so remove it from above line and uncomment below line
            // $el[0].parentElement.dispatchEvent(new Event('change'));

            // NOTE When sizes are in dropdown menu on a React site, React may ignore the synthetic click event and not recognize a size change for Add to Cart. The following can help trigger a change event in the React virtual DOM.
            // $el.parent().val($el.val());
            // $el[0].parentElement.dispatchEvent(new Event('change', {"bubbles":true, "composed":true} ));
        } else if (shop.isMobile && typeof $el.tap === 'function') {
            // in case `$el.tap()` doesn't work
            // $el[0].dispatchEvent(new Event('click'));
            // $el[0].click();
            $el.click();
            // $el.tap();
        } else if (typeof $el.click === 'function') {
            // in case `$el.click()` doesn't work
            // $el[0].dispatchEvent(new Event('click'));
            // $el[0].click();
            $el.click();
        }
        return $el;
    };

    // trim polyfills that includes quotes (IE problem)
    var trim = function (str) {
        if (typeof str !== 'string') {
            return '';
        }
        return str.replace(/^["'\s\uFEFF\xA0]+|[\s\uFEFF\xA0"']+$/g, '');
    };

    var cloneObject = function (obj) {
        try {
            return JSON.parse(JSON.stringify(obj));
        } catch (exception) {
            return null;
        }
    };

    // useful function to look up values inside deep objects
    // eslint-disable-next-line no-unused-vars
    var lookup = function (obj, path, defVal) {
        obj = obj && obj instanceof Object ? obj : {};
        defVal == null && (defVal = null);
        path === '.' && (path = '');
        var keys = Object.prototype.toString.apply(path) === '[object Array]' ? path : path.split('.');
        for (var i = 0, n = keys.length; i < n; i++) {
            var v = obj[keys[i]];
            if (v != null) {
                obj = v;
            } else {
                return defVal;
            }
        }
        return v;
    };

    // Under some circumstances, our script may be loaded before the document is ready
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            init();
        });
    }
})();
